export default "__VITE_ASSET__Dkqo6Whl__"